import React, { useState, useEffect } from 'react';
import SubThemeCircle from './SubThemeCircle';
import SubThemeExpanded from './SubThemeExpanded';
import { subThemePositions } from './constants';

const CircleTile = ({ theme, config, onClick, isActive, isExpanded, progress, studiedCountToday, totalStudiedCount, sessionCountToday, totalSessionCount, position, resetSubTheme }) => {
  const { color, subThemes } = config || { color: '#e0e0e0', subThemes: [] };
  const [expandedSubTheme, setExpandedSubTheme] = useState(null);

  useEffect(() => setExpandedSubTheme(null), [resetSubTheme]);

  const getBorderColor = (score) => score <= 50 ? `hsl(${score * 1.2}, 70%, 50%)` : `hsl(${60 + (score - 50) * 1.2}, 70%, 50%)`;

  useEffect(() => {
    const innerElement = document.querySelector(`.circle-tile[data-theme="${theme}"] .circle-tile-inner`);
    if (innerElement) setTimeout(() => innerElement.classList.add('animate'), 300);
  }, [theme, isActive]);

  const handleClick = (e) => {
    // Si le thème a des sous-thèmes et n'est pas encore étendu, on empêche la propagation pour permettre l'expansion
    if (subThemes.length > 0 && !isExpanded) e.stopPropagation();
    if (theme && !expandedSubTheme) onClick(theme);
  };

  const handleSubThemeClick = (subTheme) => setExpandedSubTheme(subTheme);
  const handleSubThemeStart = (subTheme) => { onClick(`${subTheme}-start`); setExpandedSubTheme(null); };

  return (
    <div
      className={`circle-tile ${isActive ? 'active' : ''} ${isExpanded ? 'expanded' : ''}`}
      style={{ '--start-x': `${position.x}px`, '--start-y': `${position.y}px`, transform: isExpanded ? 'translate(0, 0)' : `translate(${position.x}px, ${position.y}px)`, zIndex: isExpanded ? 10 : 2 }}
      data-theme={theme}
      onClick={handleClick}
    >
      <div className="circle-tile-inner" style={{ background: color, '--progress': `${progress}`, '--border-color-start': getBorderColor(progress), '--border-color-end': `${getBorderColor(progress)}80` }}>
        {theme ? (
          isExpanded ? (
            expandedSubTheme ? (
              <SubThemeExpanded
                subTheme={expandedSubTheme}
                theme={theme}
                color={color}
                progress={progress}
                studiedCountToday={studiedCountToday}
                totalStudiedCount={totalStudiedCount}
                sessionCountToday={sessionCountToday}
                totalSessionCount={totalSessionCount}
                onStart={() => handleSubThemeStart(expandedSubTheme)}
              />
            ) : (
              <>
                <h2 className="expanded-title">{theme}</h2>
                <p className="expanded-info">Score: {progress.toFixed(2)}%</p>
                <p className="expanded-info">Flashcards étudiées aujourd'hui: {studiedCountToday}</p>
                <p className="expanded-info">Flashcards étudiées (total): {totalStudiedCount}</p>
                <p className="expanded-info">Sessions terminées aujourd'hui: {sessionCountToday}</p>
                <p className="expanded-info">Sessions terminées (total): {totalSessionCount}</p>
                {subThemes.length > 0 && (
                  <div className="sub-themes">
                    {subThemes.map((subTheme, index) => (
                      <SubThemeCircle
                        key={subTheme}
                        subTheme={subTheme}
                        color={color}
                        position={subThemePositions[index % subThemePositions.length]}
                        progress={progress}
                        onClick={handleSubThemeClick}
                        isExpanded={expandedSubTheme === subTheme}
                        parentPosition={position}
                      />
                    ))}
                  </div>
                )}
                <button
                  className="start-session-btn"
                  onClick={() => onClick(`${theme}-start`)}
                  style={{ background: color === '#f39c12' || color === '#ff9800' ? '#333' : '#fff', color: color === '#f39c12' || color === '#ff9800' ? '#fff' : '#333' }}
                >
                  Commencer une session
                </button>
              </>
            )
          ) : (
            <>
              <span className="circle-title">{theme}</span>
              <div className="circle-progress">{progress.toFixed(2)}%</div>
            </>
          )
        ) : null}
      </div>
    </div>
  );
};

export default CircleTile;